import React, { Component } from "react";
import c from "classnames";
import { CSSTransition } from "react-transition-group";
import styles from "./style.module.scss";
import Translator from "components/Translator";
import FormField from "components/ContactForm/FormField";

const fieldsBySections = [
  {
    fields: [
      {
        col: 6,
        label: "First name*",
        labelInline: false,
        name: "first_name",
        type: "text",
        placeholder: "Enter your first name",
        validationFunction: Boolean,
        groupID: "merge_fields",
        defaultValue: "",
      },
      {
        col: 6,
        label: "Last name*",
        labelInline: false,
        name: "last_name",
        type: "text",
        placeholder: "Enter your last name",
        validationFunction: Boolean,
        groupID: "merge_fields",
        defaultValue: "",
      },
      {
        col: 6,
        label: "Work email*",
        labelInline: false,
        name: "email",
        type: "email",
        placeholder: "Enter your work email",
        validationFunction: (v) =>
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ),
        groupID: "merge_fields",
        defaultValue: "",
      },
      {
        col: 6,
        label: "Company Name*",
        labelInline: false,
        name: "company",
        type: "text",
        placeholder: "Enter your company name",
        validationFunction: Boolean,
        groupID: "merge_fields",
        defaultValue: "",
      },
      {
        col: 6,
        label: "Industry",
        labelInline: false,
        name: "industry",
        type: "text",
        placeholder: "Enter your industry",
        validationFunction: () => true,
        groupID: "merge_fields",
        defaultValue: "",
      },
      {
        col: 12,
        label: "Why would you like to use crystal? (optional)",
        labelInline: false,
        name: "00N7Q000004pcI0",
        type: "textarea",
        placeholder:
          "I’d like to use crystal because my team needs help getting data insights faster",
        validationFunction: () => true,
        groupID: "merge_fields",
        defaultValue: "",
      },
    ],
  },
  {
    fields: [
      {
        col: 12,
        label: "I accept the ",
        labelInline: true,
        name: "terms_and_conditions",
        type: "checkbox",
        validationFunction: (v) => v,
        groupID: "marketing_permissions",
        defaultValue: false,
        labelLink: "https://crystal.ai/en/legal/terms-and-conditions/",
        labelLinkText: "Terms & Conditions",
      },
      {
        col: 12,
        label: "I'd like to receive your company newsletter by email",
        labelInline: true,
        name: "newsletter",
        type: "checkbox",
        validationFunction: () => true,
        groupID: "marketing_permissions",
        defaultValue: false,
      },
    ],
  },
];

const formStatuses = {
  CLEAR: 0,
  INVALID: 1,
  VALID: 2,
  SUCCESS: 3,
  FORMAT_ERROR: 4,
  GENERIC_ERROR: 5,
};

const fieldFlatList = fieldsBySections
  .map((f) => f.fields)
  .reduce((a, f) => [...a, ...f], []);

class RequestDemoForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false,
      invalid: true,
      formStatus: formStatuses.CLEAR,

      formData: fieldFlatList.reduce(
        (a, f) => ({
          ...a,
          [f.groupID || f.name]:
            f.groupID === null
              ? f.defaultValue
              : {
                  ...a[f.groupID],

                  [f.name]: f.defaultValue,
                },
        }),
        {}
      ),
      validation: fieldFlatList.reduce(
        (a, f) => ({ ...a, [f.name]: f.validationFunction(f.defaultValue) }),
        {}
      ),
    };

    this.handleFieldChange = this.handleFieldChange.bind(this);
  }

  handleFieldChange({ name, groupID, value, isValid }) {
    this.setState((prevState) => ({
      ...prevState,

      formData: {
        ...prevState.formData,

        [groupID || name]:
          groupID === null
            ? value
            : {
                ...prevState.formData[groupID],

                [name]: value,
              },
      },
      validation: {
        ...prevState.validation,

        [name]: isValid,
      },
    }));
  }

  renderTitle() {
    return (
      <div className="row">
        <div className="col-12 col-sm-9 margin-bottom-80">
          <Translator>
            {(t) => (
              <h2 className="font-tt3 margin-bottom-32">{t("Book a demo")}</h2>
            )}
          </Translator>
          {this.renderMessage()}
        </div>
      </div>
    );
  }

  renderMessage() {
    const { formStatus } = this.state;
    const isSucceed = formStatus === formStatuses.SUCCESS;

    if (isSucceed) {
      return (
        <Translator>
          {(t) => (
            <span className="font-mini-spacemono font-color-grey">
              {t(
                "Thank you for getting in touch. Stay tuned for cool content and ideas."
              )}
              <br />
              <br />
              {t("v2_contacts-confirmation-b")}
            </span>
          )}
        </Translator>
      );
    }

    return (
      <Translator>
        {(t) => (
          <span className="font-mini-spacemono font-color-grey">
            {t(
              "Make every decision data-driven with crystal, a virtual colleague that advises you through your business data. "
            )}
          </span>
        )}
      </Translator>
    );
  }

  renderFormFields() {
    const { submitting, formStatus } = this.state;
    const isSucceed = formStatus === formStatuses.SUCCESS;

    return (
      !isSucceed &&
      fieldsBySections.map((section, i) => {
        return (
          <fieldset disabled={submitting} key={i}>
            <input type="hidden" name="oid" value="00D7Q000003R0B9" />
            <input type="hidden" name="lead_source" value="Demo Form" />
            <input type="hidden" name="retURL" value="https://www.igenius.ai" />
            <div className="row">
              {section.fields.map((field) => (
                <FormField
                  key={field.name}
                  field={field}
                  handleFieldChange={this.handleFieldChange}
                />
              ))}
            </div>
          </fieldset>
        );
      })
    );
  }

  renderFormSubmit() {
    const { submitting, validation, formStatus } = this.state;
    const invalid = Object.values(validation).includes(false);
    const isSucceed = formStatus === formStatuses.SUCCESS;

    return (
      !isSucceed && (
        <Translator>
          {(t) => (
            <div>
              <input
                type="submit"
                value={t("v2_contacts-cta")}
                disabled={submitting || invalid}
                className="font-body"
              />
              <p className="font-mini-spacemono font-color-grey margin-top-24">
                By sending this request, I accept the{" "}
                <a href="https://crystal.ai/en/legal/privacy/">
                  Privacy Policy
                </a>
              </p>
            </div>
          )}
        </Translator>
      )
    );
  }

  render() {
    const { requestDemoFormOpen, closePanel } = this.props;
    return (
      <CSSTransition
        appear
        in={requestDemoFormOpen}
        timeout={{ appear: 150, enter: 150, exit: 300 }}
        classNames={{
          appear: styles.enter,
          appearActive: styles.enterActive,
          appearDone: styles.open,
          enter: styles.enter,
          enterActive: styles.enterActive,
          enterDone: styles.open,
          exit: styles.exit,
          exitActive: styles.exitActive,
        }}
        unmountOnExit
        mountOnEnter
      >
        <div
          className={c(styles.RequestDemoForm)}
          onScroll={(e) => e.stopPropagation()}
        >
          <div
            className={c(
              styles.formSide,
              " d-flex",
              "aligns-items-center",
              "justify-content-center"
            )}
          >
            <svg
              onClick={closePanel}
              className={styles.closeSvg}
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="32"
              height="32"
              viewBox="0 0 24 24"
            >
              <defs>
                <path
                  id="closeSvg"
                  d="M7.06 6l4.42 4.419a.75.75 0 0 1-1.061 1.06L6 7.062 1.581 11.48a.75.75 0 0 1-1.06-1.061L4.938 6 .52 1.58A.75.75 0 0 1 1.58.52L6 4.94 10.42.52a.75.75 0 0 1 1.06 1.06L7.06 6z"
                />
              </defs>
              <g fill="none" fillRule="evenodd">
                <path d="M0 24h24V0H0z" />
                <g transform="translate(6 6)">
                  <mask id="closeSvgMask" fill="#fff">
                    <use xlinkHref="#closeSvg" />
                  </mask>
                  <use
                    fill="#BF2A2A"
                    fillRule="nonzero"
                    xlinkHref="#closeSvg"
                  />
                  <g fill="#2B2B2B" mask="url(#closeSvgMask)">
                    <path d="M-6-6h24v24H-6z" />
                  </g>
                </g>
              </g>
            </svg>

            <form
              id="request-demo-form"
              action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
              method="POST"
              className={c(styles.submitApplicationForm)}
              // onSubmit={(e) => {
              //   this.setState({
              //     formStatus: formStatuses.SUCCESS,
              //     submitting: false,
              //   });
              // }}
            >
              {this.renderTitle()}

              {this.renderFormFields()}

              {this.renderFormSubmit()}
            </form>
          </div>
        </div>
      </CSSTransition>
    );
  }
}

export default RequestDemoForm;



// WEBPACK FOOTER //
// ./src/components/RequestDemoForm/template.js